import {
  AGE_CHECKED
} from '../actions/types';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AGE_CHECKED:
      return action.payload;
    default:
      return state;
  }
};